"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBottomSheetBackHandler = void 0;
const react_1 = require("react");
const react_native_1 = require("react-native");
/**
 * hook that dismisses the bottom sheet on the hardware back button press if it is visible
 * @param bottomSheetRef ref to the bottom sheet which is going to be closed/dismissed on the back press
 * Issue link - https://github.com/gorhom/react-native-bottom-sheet/issues/556
 */
exports.useBottomSheetBackHandler = (bottomSheetRef) => {
    const backHandlerSubscriptionRef = react_1.useRef(null);
    const handleSheetPositionChange = react_1.useCallback((index) => {
        const isBottomSheetVisible = index >= 0;
        if (isBottomSheetVisible && !backHandlerSubscriptionRef.current) {
            // setup the back handler if the bottom sheet is right in front of the user
            backHandlerSubscriptionRef.current = react_native_1.BackHandler.addEventListener('hardwareBackPress', () => {
                bottomSheetRef.current?.dismiss();
                return true;
            });
        }
        else if (!isBottomSheetVisible) {
            backHandlerSubscriptionRef.current?.remove();
            backHandlerSubscriptionRef.current = null;
        }
    }, [bottomSheetRef, backHandlerSubscriptionRef]);
    return { handleSheetPositionChange };
};
